import { hasPayloadProgress } from '../hasProgress';

import { createDefaultSpendPointsState } from './defaults';
import type { SpendPointsPayloadBuilderState } from './types';

function snapshotSpendPointsState(state: SpendPointsPayloadBuilderState): string {
  return JSON.stringify({
    waysToBoostTiles: state.waysToBoostTiles.map((tile) => ({
      isActive: tile.isActive,
      enabledRegions: [...tile.enabledRegions].sort(),
      startAt: tile.startAt.trim(),
      endAt: tile.endAt.trim(),
      imageId: tile.imageId.trim(),
      title: tile.title.trim(),
      description: tile.description.trim(),
      ctaLabel: tile.ctaLabel.trim(),
      ctaUrl: tile.ctaUrl.trim(),
    })),
  });
}

/** Returns true when the user has entered or changed any Spend Points values from defaults. */
export function hasSpendPointsProgress(state: SpendPointsPayloadBuilderState, loadJson: string): boolean {
  return hasPayloadProgress(state, loadJson, createDefaultSpendPointsState, snapshotSpendPointsState);
}
